import { Box, Card, Grid, Skeleton } from '@mui/material'
import range from 'lodash.range'

const variants = {
    small: { cardHeight: 376, imageHeight: 200 },
    medium: { cardHeight: 416, imageHeight: 200 },
    large: { cardHeight: 636, imageHeight: 400 }
}

export type CardListSkeletonProps<Cols extends number = 1> = {
    rows?: number
    cols?: Cols
    isSkeletonButton?: boolean
    tallButton?: boolean
    variant?: keyof typeof variants
    sx?: Record<string, any>
}

export default function CardListSkeleton<Cols extends number = 1>({
    rows = 1,
    cols = 3 as Cols,
    isSkeletonButton,
    tallButton,
    variant,
    sx
}: CardListSkeletonProps<Cols>) {
    const columns = cols || 1
    const imageHeight = variant ? variants[variant].imageHeight : 200
    const cardHeight = variant ? variants[variant].cardHeight : undefined

    return (
        <Box sx={{ py: 2, ...sx }}>
            <Grid container>
                {range(rows * columns).map((index) => (
                    <Grid
                        item
                        xs={isSkeletonButton ? 4 : 12}
                        sm={isSkeletonButton ? 4 : 6}
                        md={12 / columns}
                        key={index}
                    >
                        <Card sx={{ height: cardHeight }}>
                            {isSkeletonButton ? (
                                <Skeleton
                                    variant="rectangular"
                                    height={tallButton ? 196 : 58}
                                    animation="wave"
                                />
                            ) : (
                                <>
                                    <Skeleton
                                        variant="rectangular"
                                        height={imageHeight}
                                        animation="wave"
                                    />
                                    <Box
                                        sx={{
                                            my: 2,
                                            px: 2,
                                            width: '100%'
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            <Skeleton
                                                variant="text"
                                                animation="wave"
                                                height={20}
                                                width={'30%'}
                                            />
                                            <Skeleton
                                                variant="text"
                                                animation="wave"
                                                height={20}
                                                width={'30%'}
                                            />
                                        </Box>

                                        <Skeleton
                                            variant="text"
                                            width={'80%'}
                                            animation="wave"
                                            height={30}
                                        />
                                        <Skeleton
                                            variant="text"
                                            width={'60%'}
                                            animation="wave"
                                            height={20}
                                        />
                                    </Box>
                                </>
                            )}
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}
